import {
  fetchChampionshipInfo,
  selectChampionship,
  selectMatches,
  selectPlayers,
  selectStages,
  selectStatus,
  selectTeams,
} from 'modules/client/tournaments/store/client-tournament';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch } from 'store/store';

interface IProps {
  championshipId: number;
}

function useChampionshipInfo(props: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const status = useSelector(selectStatus);
  const players = useSelector(selectPlayers);
  const teams = useSelector(selectTeams);
  const matches = useSelector(selectMatches);
  const stages = useSelector(selectStages);
  const championship = useSelector(selectChampionship);

  useEffect(() => {
    if (!status.loaded && !status.loading) {
      dispatch(fetchChampionshipInfo(props));
    }
  }, [dispatch, props, status.loaded, status.loading]);

  return {
    players,
    teams,
    matches,
    stages,
    championship,
    ...status,
  };
}

export default useChampionshipInfo;
